import React from "react";
import { FaLeaf, FaSeedling, FaSmile, FaLink, FaTools } from "react-icons/fa";

const defaultItems = [
  {
    icon : <FaLeaf size={28} />,
    title: "Find Peace with Food and Your Body",
    text : "Discover how to break free from the emotional patterns that control your relationship with food, so you can feel in control and at ease in your own skin.",
  },
  {
    icon : <FaSeedling size={28} />,
    title: "Experience Lasting Transformation",
    text : "This retreat will help you unlock deep, lasting change by addressing not just your eating habits, but the core beliefs that shape your daily life.",
  },
  {
    icon : <FaSmile size={28} />,
    title: "Embrace Self-Kindness and Compassion",
    text : "Learn to quiet your inner critic and develop a compassionate, loving relationship with yourself that extends far beyond the retreat.",
  },
  {
    icon : <FaLink size={28} />,
    title: "Connect with a Supportive Community",
    text : "Join a group of women who share your challenges and desires for change, and experience the power of community in healing.",
  },
  {
    icon : <FaTools size={28} />,
    title: "Create Lifelong Tools for Change",
    text : "Leave the retreat with practical tools that you can use every day to continue your journey towards freedom and peace.",
  },
];

function Benefit({ icon, title, text }) {
  return (
    <li className="flex gap-4 sm:gap-6 items-start w-full lg:max-w-none">
      <div className="shrink-0">
        <div className="flex items-center justify-center rounded-full bg-[#9AEEDA] p-4 sm:p-5 ring-8 ring-[#9AEEDA]/50 text-white">
          {icon}
        </div>
      </div>
      <div className="text-left">
        <h3 className="font-roboto font-semibold text-base sm:text-lg md:text-xl leading-tight">
          {title}:
        </h3>
        <p className="font-roboto text-sm sm:text-base leading-snug">{text}</p>
      </div>
    </li>
  );
}

export default function Experience({ items = defaultItems }) {
  return (
    <section className="py-8 sm:py-12 px-4 sm:px-[10%] bg-white">
      <h2 className="font-century text-2xl sm:text-3xl md:text-4xl text-left pb-8 sm:pb-12 pl-4 sm:pl-16">
        Experience Lasting Change: The Benefits and Structure of the Retreat
      </h2>
      <ul className="grid gap-8 sm:gap-10 md:gap-12 lg:gap-14 grid-cols-1 md:grid-cols-2 lg:grid-cols-1 max-w-7xl mx-auto">
        {items.map((b, idx) => (
          <Benefit key={idx} {...b} />
        ))}
      </ul>
    </section>
  );
}